module.exports = __webpack_public_path__ + "img/1.6-实地.f61c87ae.svg";